import React, {useState} from 'react';
import {Button, CircularProgress} from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import {autofillCollectionTask} from '../collectionTaskApi';

export default function AutofillButton({
    eeiIds = [],
    onResult,
    disabled = false,
}) {
    const [loading, setLoading] = useState(false);
    const enabled = !disabled && eeiIds.length > 0;

    const handleClick = async () => {
        if (!enabled) return;
        setLoading(true);
        try {
            const result = await autofillCollectionTask({eeiIds});
            onResult?.(result);
        } catch (err) {
            console.error('Autofill failed', err);
            onResult?.(null, err);
        } finally {
            setLoading(false);
        }
    };

    if (!enabled && !loading) {
        return null;
    }

    return (
        <Button
            variant="outlined"
            startIcon={loading ? <CircularProgress size={16}/> : <AutoFixHighIcon/>}
            onClick={handleClick}
            disabled={!enabled || loading}
        >
            Autofill from EEI
        </Button>
    );
}
